import { Code, FlaskConical, Palette, Megaphone, Download, UserCheck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface CallToAction {
  title: string;
  icon: LucideIcon;
  description: string;
}

const callToAction: CallToAction[] = [
  {
    title: 'Developers',
    icon: Code,
    description: 'Build the tools your community needs. Our codebase is open-source and we prioritise indigenous contributors.',
  },
  {
    title: 'Researchers',
    icon: FlaskConical,
    description: 'Study identity, governance, and trust in indigenous contexts. Our infrastructure provides a real-world research platform.',
  },
  {
    title: 'Designers',
    icon: Palette,
    description: 'Help us create interfaces that respect indigenous aesthetics, accessibility needs, and cultural protocols.',
  },
  {
    title: 'Community Leaders',
    icon: Megaphone,
    description: "Let us know what's needed and how it needs to work to support your community aspirations.",
  },
];

const links = {
  download: 'https://matou.nz/downloads',
  register: '/join',
};

export default function GetInvolved() {
  return (
    <section className="py-16 md:py-24 bg-matou-teal-dark">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4 text-center">
          Everyone's Welcome
        </h2>
        <p className="font-mono text-sm text-matou-teal-soft leading-relaxed text-center mb-8 max-w-2xl mx-auto">
          If this resonates with you, register below and join us on the journey.
        </p>

        {/* Roles — 4-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 my-20 mb-10" style={{ marginTop: '5rem', marginBottom: '5rem' }}>
          {callToAction.map((cta) => {
            const Icon = cta.icon;
            return (
              <div key={cta.title} className="text-center md:px-3">
                <div className="w-14 h-14 rounded-full bg-white/[0.08] border border-white/15 flex items-center justify-center mx-auto mb-4">
                  <Icon size={28} className="text-matou-teal-soft" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-sm font-bold text-white mb-2">
                  {cta.title}
                </h3>
                <p className="font-mono text-xs text-white/65 leading-relaxed">
                  {cta.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={links.download}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-mono text-sm font-semibold px-7 py-3 rounded-lg bg-matou-teal-soft text-matou-teal-dark hover:opacity-85 transition-opacity"
          >
            <Download size={18} />
            Join via our Community App
          </a>
          <span className="font-mono text-sm text-white/50">or</span>
          <a
            href={links.register}
            className="inline-flex items-center gap-2 font-mono text-sm font-semibold px-7 py-3 rounded-lg bg-white/[0.08] text-matou-teal-soft border border-white/20 hover:bg-white/[0.12] transition-colors"
          >
            <UserCheck size={18} />
            Register your interest
          </a>
        </div>
      </div>
    </section>
  );
}
